import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
export class PublicWidgetsService {
    constructor() {
        this.buildVideoCardsDeeplinkUrl = ({ channelId, videoId, fallbackUrl, instance, }) => this.buildDeeplinksUrl({
            host: PRODUCTION_HOSTS.catalog,
            channelId,
            videoId,
            fallbackUrl,
            instance,
        });
        this.buildChannelCardsDeeplinkUrl = ({ channelId, fallbackUrl, instance, }) => this.buildDeeplinksUrl({
            host: PRODUCTION_HOSTS.catalog,
            channelId,
            fallbackUrl,
            instance,
        });
    }
    buildQueryString(config) {
        const params = [];
        for (const key in config) {
            if (config[key]) {
                params.push(`${key}=${config[key]}`);
            }
        }
        return params.join('&');
    }
    buildDeeplinksUrl(config) {
        const { host, channelId, videoId, instance, fallbackUrl } = config;
        const params = {
            fallback_url: fallbackUrl,
            list_id: channelId,
            item_id: videoId,
            instance,
        };
        const queryString = this.buildQueryString(params);
        return `${host}/public/widgets/deeplinks/active/redirect?${queryString}`; // TODO: this creates UoU reference to PublicV2, replace with new v3 endpoint when VOD-6323 ready
    }
}
//# sourceMappingURL=widgets.js.map